// Getters
export const SUMM_IS_ERROR = 'summary/stateSummIsError';
export const SUMM_IS_LOADING = 'summary/stateSummIsLoading';
export const SUMM_GET_DATA = 'summary/stateSummData';
export const SUMM_GET_FILTER = 'summary/stateSummFilter';
export const SUMM_GET_MANY_RECORDS_ALERT = 'summary/stateSummGetManyRecordsAlert';

// Actions
export const SUMM_ACTION_FILTER = 'summary/stateSummActionSearchByFilter';
export const SUMM_ACTION_TABLE_REF = 'summary/stateSummActionTableRef';
export const SUMM_ACTION_MANY_RECORDS_ALERT = 'summary/stateSummActionTooManyRecordsAlert';



// WEBPACK FOOTER //
// ./src/store/types_summary.js